import { AfterViewInit, EventEmitter, HostBinding, Input, Output, Directive } from "@angular/core";
import { Fiat } from "@models";
import { isTrueProperty } from "../../../core/util/component-util";
import { TradableListService } from "@main-services/currency/tradable_list.service";
import { FiatService } from "@main-services/currency";
import { TradableWalletListService } from "@main-services/wallet/tradable_wallet_list.service";
import { TransactionWrapperModalComponent } from "../../modals/transaction-wrapper-modal/transaction-wrapper-modal.component";
import { TradableWallet } from "@models/interfaces/tradable_wallet";
import { Tradable } from "@models/interfaces/tradable";
import { convertTradableToFiat } from "@helpers/tradable-convert";
import { TradableTransaction, Transaction } from "@models/transaction";
import { ModalService } from "@core-services/modal.service";
import { MasterdataService } from "@core-services/masterdata.service";

@Directive()
export abstract class CurrencyTransactionListItemComponent implements AfterViewInit {
	@Input()
	public abstract transaction: Transaction;

	@Input()
	public canOpen: boolean = true;

	@Input()
	public activity: string = "";

	@Output()
	public closeEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

	@Input()
	public showShareButton: boolean = false;

	@Input("compact")
	@HostBinding("attr.compact")
	public set compact(val: boolean) {
		this._compact = isTrueProperty(val);
	}

	public get compact(): boolean {
		return this._compact;
	}

	@Input("wide")
	@HostBinding("attr.wide")
	public set wide(val: boolean) {
		this._wide = isTrueProperty(val);
	}

	public get wide(): boolean {
		return this._wide;
	}

	protected _wide;
	public pid: string = "";

	protected _compact;

	public abstract get fiat(): Fiat;

	public constructor(
		protected masterdataService: MasterdataService,
		protected tradableWalletListService: TradableWalletListService,
		protected fiatService: FiatService,
		protected tradableListService: TradableListService,
		protected modalService: ModalService
	) {}

	public ngAfterViewInit(): void {
		this.initPidValue();
	}

	protected initPidValue(): void {
		const prefix = this.transaction.hasTrade() && !this.transaction.isCard() ? "T" : "F"; // For fiat-tx, overwritten for asset-tx
		const id =
			this.transaction.hasTrade() && !this.transaction.isCard()
				? this.transaction.getTrade().getId()
				: this.transaction.getId();
		this.pid = prefix + id;
	}

	public isIndexTx(): boolean {
		return this.transaction.isIndex();
	}

	public toggle(): void {
		if (!this.canOpen) {
			return;
		}
		const modal = this.modalService.create(TransactionWrapperModalComponent, {
			transaction: this.transaction,
			activity: this.activity,
			canOpen: false,
			showShareButton: this.showShareButton
		});
		modal.present();
	}

	public getCurrencyId(): string {
		return this.tradable.getId();
	}

	public get tradable(): Tradable {
		return this.tradableListService.getItemById(this.transaction.getCurrencyId());
	}

	public isActivityOrHistory(): boolean {
		return this.activity === "activity" || this.activity === "history";
	}

	public get wallet(): TradableWallet {
		return this.tradableWalletListService.getItemById(this.transaction.getWalletId(), true);
	}

	public fiatAmount(transaction: TradableTransaction): number {
		const trade = transaction.getTrade();
		return convertTradableToFiat(this.tradable, trade.getPrice(), this.fiat);
	}
}
